import { useContext } from "react"
import { EstrategiasFornecedorContext } from "./EstrategiasFornecedorContext"

export function useEstrategiasFornecedorContext() {
    return useContext(EstrategiasFornecedorContext)
}
